import PrescriptionPrintLayout, {
  PrintHospital,
  PrintDoctor,
  PrintPatient,
  PrintVitals,
} from './PrescriptionPrintLayout';

// ── Public types ───────────────────────────────────────────────────

export interface ManualRxData {
  hospital:    PrintHospital;
  doctor:      PrintDoctor;
  patient:     PrintPatient;
  encounterId: string;
  date?:       string;
  vitals?:     PrintVitals;
}

interface Props {
  data:   ManualRxData;
  onDone: () => void;
}

// ── Component ──────────────────────────────────────────────────────

export default function ManualPrescriptionPrint({ data, onDone }: Props) {
  const blankCanvas = (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', paddingTop: '4px' }}>
      {/* Rx symbol + guidance */}
      <div style={{
        display:      'flex',
        alignItems:   'baseline',
        gap:          '8px',
        marginBottom: '6px',
        flexShrink:   0,
      }}>
        <span style={{
          fontFamily: 'Georgia, serif',
          fontWeight: 700,
          fontSize:   '24pt',
          color:      '#374151',
          lineHeight: 1,
        }}>
          Rx
        </span>
        <span style={{ fontSize: '7pt', color: '#9ca3af', fontStyle: 'italic' }}>
          Write medicines, dosage, and instructions below
        </span>
      </div>
      {/* Blank writing area */}
      <div style={{ flex: 1, background: '#fff' }}/>
    </div>
  );

  return (
    <PrescriptionPrintLayout
      hospital={data.hospital}
      doctor={data.doctor}
      patient={data.patient}
      encounterId={data.encounterId}
      date={data.date}
      vitals={data.vitals}
      onDone={onDone}
    >
      {blankCanvas}
    </PrescriptionPrintLayout>
  );
}
